import {
    nFormatter,
    createSeries,
    createSQL,
    seriesHead,
    appendAggregateValues,
    seriesDataItem,
    pickItem,
    isDateTransformation,
    highestModel,
    averageModel,
    missingValuesModel,
    resolve,
    getSeriesColors,
    extractColors,
    createFilter
  } from "@/components/charts/common";
  
  // import pluralize from 'pluralize';
  import apexChartOptions from "@/common/apex-chart-defaults";

export default function hydrator(parameters, d, chart) {

    try {
        let formSchema = resolve("formSchema.value", parameters);
        chart.schema = JSON.parse(formSchema);
        // alert(formSchema);
    } catch(error) {

    }
    
}